import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  drinkStatsControllerGetDrinkMargin,
  drinkStatsControllerGetDrinkProfit,
  drinkStatsControllerGetExtraOverview,
  drinkStatsControllerGetIngredientConsumption,
  drinkStatsControllerGetTopDrinks,
} from '@klubovna/api-client';
import {
  DrinkMarginDto,
  DrinkProfitDto,
  ExtraOverviewDto,
  IngredientConsumptionDto,
  TopDrinkDto,
} from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DrinkStatsDateParams {
  dateFrom?: string;
  dateTo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DrinkStatsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getTopDrinks(params?: DrinkStatsDateParams): Observable<TopDrinkDto[]> {
    return drinkStatsControllerGetTopDrinks(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as TopDrinkDto[]));
  }

  getIngredientConsumption(params?: DrinkStatsDateParams): Observable<IngredientConsumptionDto[]> {
    return drinkStatsControllerGetIngredientConsumption(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as IngredientConsumptionDto[]));
  }

  getMargin(params?: DrinkStatsDateParams): Observable<DrinkMarginDto[]> {
    return drinkStatsControllerGetDrinkMargin(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as DrinkMarginDto[]));
  }

  getExtraOverview(params?: DrinkStatsDateParams): Observable<ExtraOverviewDto> {
    return drinkStatsControllerGetExtraOverview(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as ExtraOverviewDto));
  }

  getProfit(params?: DrinkStatsDateParams): Observable<DrinkProfitDto> {
    return drinkStatsControllerGetDrinkProfit(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as DrinkProfitDto));
  }
}
